<template>
	<dialog-slot
			:title="getModalTitle"
			@updateClose="onClose"
			@updateSave="onSave"
			apply-text="Create statements"
			width="680px"
	>
		<div class="groupField_wrap">
			<field
					:class-error="getError('customer_id')"
					margin="0 10px 10px 0"
					width="200px"
					label="Customer"
					placeholder="Choose customer"
					@updateAutocomplete="onAutocomplete($event, 'customer_id')"
					:autocompleteValue="customer_id"
					:items="customer"
					:isClearable="false"
					is-autocomplete
					is-required
			></field>
			<field
					:class-error="getError('start_day')"
					margin="0 10px 10px 0"
					width="200px"
					type="text"
					label="Date from"
					placeholder="Enter date"
					:dateValue="start_day"
					@updateDate="onDate($event, 'start_day')"
					is-date
					is-no-title
					is-required
			></field>
			<field
					:class-error="getError('end_day')"
					margin="0 0 10px 0"
					width="200px"
					type="text"
					label="Date to"
					placeholder="Enter date"
					:dateValue="end_day"
					@updateDate="onDate($event, 'end_day')"
					is-date
					is-no-title
					is-required
			></field>
		</div>
		<preload v-if="isPreloader"></preload>
		<driver-table
				:list-items="contract"
				:indeterminate="indeterminate"
				:checkAll="checkAll"
				@updateCheckOrder="onCheckOrder($event, 'contract')"
				@updateCheckOrders="onCheckOrders($event, 'contract')"
		></driver-table>
	</dialog-slot>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// components
import DriverTable from "@/components/Accounting/DriverStatements/DriverTable/DriverTable";
// shared
import Preload from "@/shared/Preload/Preload";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment/moment";
import checkBoxOrders from "@/mixins/checkBoxOrders";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "CreateStatements",
	mixins: [ validationMixin, checkBoxOrders ],
	components: {
		DialogSlot,
		Preload,
		DriverTable
	},
	props: {
		dayOffId: Number
	},
	computed: {
		isAllowSave() {
			return !(this.selected.length && this.customer_id && this.start_day && this.end_day);
		},
		getModalTitle() {
			return `${ this.dayOffId ? 'Edit' : 'Create' } statements`;
		}
	},
	data: () => ({
		isPreloader: false,
		start_day: null,
		end_day: null,
		customer_id: null,
		customer: [],
		contract: []
	}),
	validations: {
		end_day: { required },
		start_day: { required },
		customer_id: { required }
	},
	methods: {
		...mapActions([
			'onDayOffCreate',
			'onDayOff',
			'onDayOffFilter',
			'setAlert',
			'onDriverStatementsCreate',
			'onDayOffEdit',
			'onDriverStatementsSave'
		]),
		getError(key) {
			return this.$v[key]?.$error;
		},
		async onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
			await this.getContractForCustomer();
		},
		async onDate(date, key) {
			this[key] = date;
			await this.getContractForCustomer();
		},
		onClose() {
			this.$emit('updateClose');
		},

		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					customer_id,
					start_day,
					end_day,
					selected
				} = this.$data;

				const values = {
					customer_id,
					from: start_day,
					to: end_day,
					contract: selected
				};

				const validTime = moment(start_day).isBefore(end_day);

				if (validTime) {
					this.isPreloader = true;
					const { status } = await this.onDriverStatementsSave(values);
					if (status) {
						this.onClose();
						this.setAlert({ type: "success", message: "Saving Successfully" });
					} else {
						this.setAlert({ type: "error", message: "Saving error" });
					}
					this.isPreloader = false;
				} else {
					this.setAlert({ type: "error", message: "Start day, should be less than the end of day" });
				}
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		async getContractForCustomer() {
			const values = {
				customer_id: this.customer_id,
				from: this.start_day,
				to: this.end_day
			};

			if (this.customer_id && this.start_day && this.end_day) {
				this.isPreloader = true;
				const { contract, customer } = await this.onDriverStatementsCreate(values);
				this.customer = customer;
				this.contract = contract;
				this.selected = [];
				this.indeterminate = false;
				this.checkAll = false;
				this.isPreloader = false;
			}
		}
	},
	async mounted() {
		this.isPreloader = true;
		const { contract, customer } = await this.onDriverStatementsCreate();
		this.customer = customer;
		this.contract = contract;

		this.isPreloader = false;
	}
};
</script>

<style scoped lang="scss">
@import "CreateStatements";
</style>

<style lang="scss">
@import "CreateStatementsAll";
</style>

